import React from "react";
import { Form } from "modules/forms/hooks/usefetchForm";
import useTrans from "components/hooks/useTrans";

type Props = {
    form: Form
}

export default function FormIsNotActive(props: Props) {
    const { t } = useTrans();

    return (
        <div className={"flex items-center justify-center"}>
            <p>{t("thisFormIsNotActive")}</p>
        </div>
    );
}